import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { getA6StaticDataColumns, type A6StaticDatum } from "./columns";
import {
  type FilterA6StaticDatumsSchema,
  FilterA6StaticDatums,
} from "./filter";

const client = "a6";
const table_name = "a6_static_data";

export const A6StaticDatumsTable = () => {
  const { t } = useTranslation();
  const columns = getA6StaticDataColumns(t);

  return (
    <Table<A6StaticDatum, FilterA6StaticDatumsSchema>
      label={t("a6_static_data.title", {
        ns: "tables",
        defaultValue: "Actifs",
      })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterA6StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
